import React, { useState } from "react";
import {Slider,ComparisonCard } from '../components';

const Pricing = () => {
  const [formData, setFormData] = useState({
    sliderValue1: 1000,
    sliderValue2: 250,
  });

  const handleSliderChange = (sliderIndex) => (value) => {
    setFormData((prevData) => ({
      ...prevData,
      [`sliderValue${sliderIndex}`]: value,
    }));
  };

  const calculateTotalRevenue = () => {
    return formData.sliderValue1 * formData.sliderValue2;
  };

  const totalRevenue = calculateTotalRevenue();

  const calculateEarnings = (rate) => {
    return totalRevenue * (1 - rate);
  };

  const calculateExtraFees = (competitorRate, tmtRate) => {
    return totalRevenue * (competitorRate - tmtRate);
  };

  const platforms = [
    {
      name: "TakeMyTickets",
      rate: 0.01,
      happyEmoji: true,
      neutralEmoji: false,
      sadEmoji: false,
    },
    {
      name: "BookMyShow",
      rate: 0.1,
      happyEmoji: false,
      neutralEmoji: true,
      sadEmoji: false,
    },
    // {
    //   name: "Paytm Insider",
    //   rate: 0.12,
    //   happyEmoji: false,
    //   neutralEmoji: false,
    //   sadEmoji: true,
    // },
  ];

  const tmtRate = platforms[0].rate;
  const otherExtraFees = platforms
    .slice(1)
    .map((platform) => calculateExtraFees(platform.rate, tmtRate));

  return (
    <div className="flex flex-col items-center justify-center w-full md:w-[65%] m-auto gap-6 p-4 md:p-5 pt-10 md:max-w-5xl pb-24">
  <div className="flex flex-col gap-4 items-center justify-center pb-4 w-full">
    <div className="text-grey-70 px-4 py-2 text-center flex items-center bg-white rounded-full w-fit m-auto border border-grey-70 text-sm md:text-base">
      Calculate your savings
    </div>
    <div className="text-center heading-36 md:text-[56px] font-black text-black leading-snug">
      <span className="text-primary"> Save more</span> on event fees with us!
    </div>
  </div>

  {/* Sliders */}
  <div className="flex flex-col items-center w-full gap-12 md:gap-20">
    {/* First Slider */}
    <div className="flex flex-col w-full md:w-[110%] gap-3 max-w-5xl">
      <div className="flex justify-between items-center text-sm md:text-base">
        <label className="font-semibold">Avg. Entry Fee</label>
        <output className="text-xl md:text-2xl font-semibold">
          <span className="text-gray-500 text-sm md:text-lg font-medium">₹</span> {formData.sliderValue1}
        </output>
      </div>
      <Slider
        onSliderChange={handleSliderChange(1)}
        sliderValue={formData.sliderValue1}
        setFormData={setFormData}
        formData={formData}
        min={50}
        max={10000}
      />
    </div>

    {/* Second Slider */}
    <div className="flex flex-col w-full md:w-[110%] gap-3 max-w-5xl">
      <div className="flex justify-between items-center text-sm md:text-base">
        <label className="font-semibold">Attendees Per Event</label>
        <output className="text-xl md:text-2xl font-semibold">
          {formData.sliderValue2}
        </output>
      </div>
      <Slider
        onSliderChange={handleSliderChange(2)}
        sliderValue={formData.sliderValue2}
        setFormData={setFormData}
        formData={formData}
        min={20}
        max={5000}
      />
    </div>
  </div>

  {/* Comparison Cards */}
  <div className="flex flex-wrap justify-center md:justify-evenly w-full gap-3 md:gap-5 mt-5">
    {platforms.map((platform, index) => (
      <ComparisonCard
        key={index}
        platformName={platform.name}
        price={totalRevenue}
        extraFees={index === 0 ? 0 : calculateExtraFees(platform.rate, tmtRate)}
        earnings={calculateEarnings(platform.rate)}
        happyEmoji={platform.happyEmoji}
        neutralEmoji={platform.neutralEmoji}
        sadEmoji={platform.sadEmoji}
        isFirstItem={index === 0}
        otherExtraFees={index === 0 ? otherExtraFees : []}
      />
    ))}
  </div>
</div>
  )
};

export default Pricing;
